import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ProductCard from '../ProductCard';
import './popularMenu.css';
import { popularMenuFood } from '../../assets/fake-data/products';

const PopularMenu = () => {
    return (
        <section className="pt-0">
            <Container>
                <Row>
                    <Col lg="12" className="mb-5">
                        <h2>Popular Food Menu</h2>
                    </Col>

                    {popularMenuFood.map((item) => (
                        <Col lg="3" md="4" sm="6" key={item.id}>
                            <ProductCard item={item} />
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default PopularMenu;
